import { useMemo } from 'react';

import { keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn } from '@Components/Grid/utils/column';

import ActionFormatter from './ActionFormatter';
import ColorizeNumberFormatter from './ColorizeNumberFormatter';
import DateFormatter from './DateFormatter';
import DetailsEntity from './DetailsEntity';
import EntityLinkFormatter from './EntityLinkFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumn('bucket_id', 'Bucket ID', info => info.getValue() || '--', { initialSize: 'min-w-[8vw]' }),
    column.accessor('ref_date', {
      header: 'Date',
      cell: info => <DateFormatter info={info} />,
      enableTruncateTooltip: true,
    }),
    column.accessor('', {
      header: 'Action',
      cell: info => <ActionFormatter info={info} />,
      size: 100,
    }),
    column.accessor('publisher_name', {
      header: 'Publisher',
      cell: info => <EntityLinkFormatter entity='publisher' info={info} />,
    }),
    defaultColumn('subid', 'SubID', undefined, { initialSize: 'max-w-[8vw]', enableTruncateTooltip: true }),
    column.accessor('transaction_value', {
      header: 'Value',
      cell: info => <ColorizeNumberFormatter info={info} />,
    }),
    column.accessor('bucket_value', {
      header: 'Prev. Balance',
      cell: info => <ColorizeNumberFormatter info={info} />,
      size: 100,
    }),
    defaultActionsColumn(detailsAction),
  ], [])
}

function detailsAction(info) {
  return <DetailsEntity key={keyOf(info, 'details')} info={info} />
}
